import type { ShiftBreak } from '@libs/data-access/queries'
import moment from 'moment'

import type { BreakRow } from '../components/BreakRowsContainer/BreakRowsContainer'

const getBreaks = (
  defaultBreak?: number,
  shiftBreaks?: ShiftBreak[],
  shiftId?: number
): { value: BreakRow }[] => {
  if (shiftBreaks && shiftBreaks.length > 0) {
    return shiftBreaks.map(shiftBreak => ({
      value: {
        id: shiftBreak.id,
        plannedDuration: shiftBreak.planned_duration,
        ...(shiftBreak.planned_starts_at && {
          timeRange: [
            moment(shiftBreak.planned_starts_at).format('HH:mm'),
            moment(shiftBreak.planned_ends_at).format('HH:mm')
          ]
        })
      } as BreakRow
    }))
  }

  return defaultBreak && !shiftId
    ? [
        {
          value: {
            id: undefined,
            plannedDuration: defaultBreak,
            timeRange: [] as string[]
          }
        }
      ]
    : []
}

export default getBreaks
